import { Link } from "react-router-dom";
import { Icon } from "../../components";
import { TODOLIST_GRID_LABELS } from "../shared/util/docuMateLabel";
import { CommonUtility } from "../../Services/CommonUtility";
import moment from "moment";

const IdleTimeInHours = 48;

export const getRefiGridColumns = (handleDocumentClick, toggleLockDocument) => {
    let gridcolumns = [
        {
            Header: TODOLIST_GRID_LABELS.fileName,
            accessor: 'fileName',
            Cell: row => {
              return (
                  <div className={CommonUtility.compareTimeDifferenceWithCurrent(row.row?.original?.dateAvailable, IdleTimeInHours) ? 'todoList-grd-cell RefiTODoGridCellBackgroundColor' : 'todoList-grd-cell'}>
                      <Link
                      to={{
                          pathname: '',
                          state: { scanId: row.row?.original?.fileName, id: row.row?.original?.refiRequestId }                            
                      }}
                      onClick={(event) => {
                        event.preventDefault(); 
                        handleDocumentClick(row.row?.original?.refiRequestId)
                      }}
                      className="text-start text-decoration-none d-block"
                      title="row.value"
                      style={{ marginRight: '0.5em' }}
                      ><span title={row.row?.original?.fileName}>{row.row?.original?.fileName}</span></Link>
                      <div style={{ display: 'flex', justifyContent: 'flex-end'}}>
                      {
                        (() => {
                            const status = row.row?.original?.status;
                            const updatedBy = row.row?.original?.updatedBy;
                            console.log('status', status);
                            switch (true) {
                                case status === 'InProgress':
                                  return <Icon title={updatedBy} icon="userPen" className='grd-cell-icon--working' />;
                                // case data?.isLocked:
                                //     return <Icon icon="lock" className='grd-cell-icon--hardlock' 
                                //             onClick = {(event) => {
                                //             event.preventDefault();
                                //             toggleLockDocument(data?.refiRequestId, data?.isLocked);}}/>;
                                // case !data?.isLocked:
                                //     return <span>
                                //               <Icon icon="lock" className='grd-cell-icon--lock' 
                                //               onClick = {(event) => {
                                //               event.preventDefault();
                                //               toggleLockDocument(data?.refiRequestId, data?.isLocked);
                                //               }}/>
                                //           </span>;
                                default:
                                  return null;
                            }
                        })()
                    }
                      </div>
                  </div>
              )
            },
            width:325
        },
        {
          Header: TODOLIST_GRID_LABELS.docDescription,
          accessor: 'docDesc',
          Cell: row => {
            return (
                <div className={CommonUtility.compareTimeDifferenceWithCurrent(row.row?.original?.dateAvailable, IdleTimeInHours) ? 'gridNavigateButton text-start text-decoration-none d-block p-2 RefiTODoGridCellBackgroundColor' : 'gridNavigateButton text-start text-decoration-none d-block p-2'}>
                  <span title={row.row?.original?.docDesc}>{row.row?.original?.docDesc}</span>
              </div>
            )
          },
          width:950
        },
        {
          Header: TODOLIST_GRID_LABELS.dateInitiated,
          accessor: 'dateInitiated',
          Cell: row => {
            return (
                <div className={CommonUtility.compareTimeDifferenceWithCurrent(row.row?.original?.dateAvailable, IdleTimeInHours) ? 'text-start text-decoration-none d-block p-2 RefiTODoGridCellBackgroundColor' : 'text-start text-decoration-none d-block p-2'}>
                  <span title={CommonUtility.formateDateTime(row.row?.original?.dateInitiated)}>{CommonUtility.formateDateTime(row.row?.original?.dateInitiated, CommonUtility.DateTimeFormatWithSecond)}</span>
              </div>
            )
          },
          width:250
        },
        {
          Header: TODOLIST_GRID_LABELS.dateAvailable,
          accessor: 'dateAvailable',
          Cell: row => {
            return (
                <div className={CommonUtility.compareTimeDifferenceWithCurrent(row.row?.original?.dateAvailable, IdleTimeInHours) ? 'text-start text-decoration-none d-block p-2 RefiTODoGridCellBackgroundColor' : 'text-start text-decoration-none d-block p-2'}>
                  <span title={CommonUtility.formateDateTime(row.row?.original?.dateAvailable)}>{CommonUtility.formateDateTime(row.row?.original?.dateAvailable, CommonUtility.DateTimeFormatWithSecond)}</span>
              </div>
            )
          },
          width:250
        }
      ];
    return gridcolumns;
}
